import { FC, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { ROUTES } from '../../consts/routes';
import { useAdminCardDecks } from '@olagg/api-hooks';
import CardDeckForm from './Form';
import { CreateCardDeckData } from '@olagg/db-types';
import { Spinner } from '@chakra-ui/react';
import { Heading } from '@chakra-ui/react';
import { VStack } from '@chakra-ui/react';
import { Center } from '@chakra-ui/react';

export const EditCardDeck: FC = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const { updateCardDeck, find, cardDeck, isLoading } = useAdminCardDecks();

  useEffect(() => {
    if (id) find(id);
  }, [id]);


  const handleSubmit = async (data: CreateCardDeckData) => {
    if (id) await updateCardDeck(id, data);
    navigate(ROUTES.CARD_DECKS.all);
  };

  if (isLoading) return <Spinner>Cargando...</Spinner>;
  
  if (!cardDeck) return (
    <Center w={'full'} pb={4}>
      <VStack color={'white'} w={'full'}>
        <Heading my={2}>
          Mazo de Cartas no encontrado
        </Heading>
      </VStack>
    </Center>
  );

  return (
    <Center w={'full'} pb={4}>
      <VStack color={'white'} w={'full'}>
        <Heading my={2}>
          Editar Mazo de Cartas
        </Heading>
        <CardDeckForm onSubmit={handleSubmit} cardDeck={cardDeck} />
      </VStack>
    </Center>
  );
};
